<template>
    <div>
        <h5>Terms and Conditions</h5>
        <ol>
            <li>
                <u>Definitions</u>
                <ol>
                    <li>
                        <h6>
                            <b>Platforms</b>
                            means the website(s), apps, tools, platforms and/or
                            other devices of {{ channel }} and its affiliated
                            companies and business partners on which the Service
                            is (made) available.
                        </h6>
                    </li>
                </ol>
            </li>
        </ol>
        <ol start="2">
            <li>
                <u>Lodgix Subscriber Obligations</u>
                <ol>
                    <li>
                        <h6>
                            For each reservation made on the Platforms by a
                            Guest for a Room, the Lodgix subscriber
                            <b>shall pay Lodgix.com a 2% commission</b>
                            calculated in accordance with Clause 2.2. Payment
                            shall be made in accordance with Clause 3.1. This 2%
                            commission is in addition to any commission being
                            collected separately from {{ channel }}.
                        </h6>
                    </li>
                    <li>
                        <h6>
                            The aggregate Commission per reservation is equal to
                            the multiple of (i) the number of nights stayed at
                            the Accommodation by the Guest, (ii) the booked rate
                            per room per night (<b>excluding</b>
                            sales taxes and such other applicable national,
                            governmental, provincial, state, municipal or local
                            taxes or levies and such other fees and services
                            which are included in the offered rate at the time
                            of booking of the room by a Guest on the Platforms).
                        </h6>
                    </li>
                </ol>
            </li>
        </ol>
        <ol start="3">
            <li>
                <u>Reporting and Payment of Commission</u>
                <ol>
                    <li>
                        <h6>
                            Commission for bookings in a calendar month that
                            contains the (scheduled) arrival date of the Guest
                            in such month will be invoiced (save for free
                            cancellations made through {{ channel }} and in
                            accordance with the cancellation policy of the
                            Accommodation) and paid in the subsequent month in
                            accordance with the following terms:
                        </h6>
                        <ol type="a">
                            <li>
                                <h6>
                                    Invoices are automatically processed on a
                                    monthly basis between the 1st and 15th of
                                    the month. An itemized invoice will be made
                                    available within the Manage Billing &gt;
                                    Show / Hide Invoices area of Lodgix.com
                                    detailing all the reservations and resulting
                                    commission charges incurred in the previous
                                    month. The Lodgix subscriber’s credit card
                                    on file will be billed automatically for
                                    these charges.
                                </h6>
                            </li>
                        </ol>
                    </li>
                </ol>
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    name: 'PartnerNextpaxTermsAndConditions',
    props: {
        channel: String,
    },
};
</script>